import { render, staticRenderFns } from "./AllResults.vue?vue&type=template&id=22febb1a&scoped=true"
import script from "./AllResults.vue?vue&type=script&lang=js"
export * from "./AllResults.vue?vue&type=script&lang=js"
import style0 from "./AllResults.vue?vue&type=style&index=0&id=22febb1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22febb1a",
  null
  
)

export default component.exports